import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "p-2.5 w-full create-catalog"
}
const _hoisted_2 = { class: "flex justify-between items-center pb-5" }
const _hoisted_3 = { class: "card-header font-bold" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "Variant devs", -1)
const _hoisted_5 = { class: "w-full flex items-center justify-end pt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_SaveButton = _resolveComponent("SaveButton")!
  const _component_CatalogInfomationCard = _resolveComponent("CatalogInfomationCard")!
  const _component_CatalogVariants = _resolveComponent("CatalogVariants")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_CloseButton = _resolveComponent("CloseButton")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_sectionLayoutContent = _resolveComponent("sectionLayoutContent")!

  return (_openBlock(), _createBlock(_component_sectionLayoutContent, _mergeProps(_ctx.content, {
    backPageTitle: "Back",
    style: {"overflow":"hidden"}
  }), {
    default: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_el_skeleton, {
            key: 0,
            rows: 5,
            animated: ""
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_PageTitle, { title: `Update Catalog` }),
              _createVNode(_component_SaveButton, { onClick: _ctx.updateCatalog }, null, 8, ["onClick"])
            ]),
            _createVNode(_component_el_row, { gutter: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 18 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.catalog.name) + " ", 1),
                    _createVNode(_component_CatalogInfomationCard, {
                      catalog: _ctx.catalog,
                      hidden: ""
                    }, null, 8, ["catalog"]),
                    _createVNode(_component_el_card, { class: "mt-3" }, {
                      header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _hoisted_4,
                          _createTextVNode(" " + _toDisplayString(_ctx.catalog.variants.length) + " variants - " + _toDisplayString(_ctx.catalog.sizes.length) + " sizes - " + _toDisplayString(_ctx.catalog.colors.length) + " colors ", 1)
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_CatalogVariants, {
                          isEditable: true,
                          variants: _ctx.catalog.variants,
                          colors: _ctx.catalog.colors,
                          sizes: _ctx.catalog.sizes,
                          productCode: _ctx.catalog.productCode,
                          designs: _ctx.catalog.designs
                        }, null, 8, ["variants", "colors", "sizes", "productCode", "designs"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 6 }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_CloseButton, {
                        label: `Discard`,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fetchCatalog()))
                      }),
                      _createVNode(_component_SaveButton, {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateCatalog()))
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
    ]),
    _: 1
  }, 16))
}